import 'react-multi-carousel/lib/styles.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Carousel from 'react-multi-carousel';
import { MediaAsset } from '@/types/api/media';
import { MediaAssetDisplay } from '@/components/media-asset-display';
import { Image } from '@/components/image';

type Props = {
  assets: (MediaAsset & { primary: boolean })[];
};

const ImageCarousel = ({ assets }: Props) => {
  return (
    <div className="max-w-[600px]">
      <Carousel
        infinite
        arrows
        autoPlay
        autoPlaySpeed={3000}
        responsive={{
          all: {
            items: 1,
            breakpoint: { max: 4000, min: 0 },
          },
        }}
      >
        {assets.map((asset) => (
          <Image
            className="rounded-md"
            renditions={Object.values(asset.renditions)}
            alt={asset.name}
            priority={asset.primary}
            sizes="(min-width: 600px) 600px, 100vw"
          />
        ))}
      </Carousel>
    </div>
  );
};

export default ImageCarousel;
